// Mirrors Finkit.Permissions.HostPagesPermissions.FinkitHostPagesPermissions.Cents.
export const CentsPermissions = {
  view: 'HostPages.Cents',
  create: 'HostPages.Cents.Create',
  edit: 'HostPages.Cents.Edit',
  delete: 'HostPages.Cents.Delete',
} as const;
